import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ActionBase } from 'store/ActionBase';
import { AuthorizeV1Data, saveGenerator as saveGeneratorV1 } from 'store/connect/AuthorizeV1Data';
import { saveGenerator as saveGeneratorV2 } from 'store/connect/AuthorizeV2Data';
import { useReceiveV2AuthorizeRequest } from './UseReceiveV2AuthorizeRequest';

/**
 * 認可エンドポイントからのリクエストを受け取るhook
 */
export const useReceiveAuthorizeRequest = (dispatch: React.Dispatch<ActionBase>) => {
	const location = useLocation();
	const search = location.search;
	const queryParams = new URLSearchParams(search);

	/**
	 * 認可エンドポイントv1から来た場合のパラメータ
	 * GETで飛んでくるのでReact上はURLデコードされた状態
	 */
	// burlはデコードしないで取得する
	const burl = queryParams.get('burl'); // 戻り先URL
	const bsn = queryParams.get('bsn'); // 戻す際のリンクの表示サイト名
	const scd = queryParams.get('scd'); // サービスサイトコード
	const shopcd = queryParams.get('shopcd'); // ショップコード
	const isV1ParamsOk = !!burl && !!bsn;
	const v1Params: AuthorizeV1Data = { burl, bsn, scd, shopcd };
	useEffect(() => {
		if (isV1ParamsOk) {
			saveGeneratorV1(dispatch, v1Params);
		}
	}, [isV1ParamsOk]);

	/**
	 * 認可エンドポイントv2から来た場合のパラメータ
	 * GETで飛んでくるのでReact上はURLデコードされた状態
	 */
	const { v2Params, isV2ParamsOk } = useReceiveV2AuthorizeRequest();
	useEffect(() => {
		if (isV2ParamsOk) {
			saveGeneratorV2(dispatch, v2Params);
		}
	}, [isV2ParamsOk]);

	return {
		isV1ParamsOk,
		isV2ParamsOk,
		burl,
		bsn,
		scd,
		redirect_uri: v2Params.redirect_uri,
		client_id: v2Params.client_id,
	};
};
